const MARKET_SOCKET_URL = process.env.VUE_APP_MARKET_SOCKET_URL
const RECONNECT_DELAY = 5000
const HEARTBEAT_INTERVAL = 30000
const HEARTBEAT_MESSAGE = JSON.stringify({ type: 'ping' })

let marketSocket = null
let reconnectTimer = null
let heartbeatTimer = null
const messageListeners = new Set()

function notifyMessageListeners(event) {
  let message = event.data
  if (typeof message === 'string') {
    try {
      message = JSON.parse(message)
    } catch (error) {
      return
    }
  }
  messageListeners.forEach(listener => listener(message, event))
}

function clearReconnectTimer() {
  if (!reconnectTimer) return
  window.clearTimeout(reconnectTimer)
  reconnectTimer = null
}

function clearHeartbeatTimer() {
  if (!heartbeatTimer) return
  window.clearInterval(heartbeatTimer)
  heartbeatTimer = null
}

function sendHeartbeat() {
  if (marketSocket && marketSocket.readyState === window.WebSocket.OPEN) {
    marketSocket.send(HEARTBEAT_MESSAGE)
  }
}

function sendLoginVerification() {
  const accessToken = localStorage.getItem('token')
  if (!accessToken || !marketSocket || marketSocket.readyState !== window.WebSocket.OPEN) return false
  marketSocket.send(JSON.stringify({
    type: 'login',
    source: 'web',
    access_token: accessToken,
    scene: 'auth'
  }))
  return true
}

function startHeartbeat() {
  clearHeartbeatTimer()
  sendHeartbeat()
  heartbeatTimer = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL)
}

function scheduleReconnect() {
  clearReconnectTimer()
  if (!localStorage.getItem('token')) return
  reconnectTimer = window.setTimeout(connectMarketSocket, RECONNECT_DELAY)
}

export function connectMarketSocket() {
  if (typeof window === 'undefined' || typeof window.WebSocket === 'undefined') return null
  if (marketSocket && [window.WebSocket.OPEN, window.WebSocket.CONNECTING].includes(marketSocket.readyState)) {
    return marketSocket
  }

  clearReconnectTimer()
  try {
    marketSocket = new window.WebSocket(MARKET_SOCKET_URL)
  } catch (error) {
    marketSocket = null
    scheduleReconnect()
    return null
  }
  marketSocket.onopen = () => {
    clearReconnectTimer()
    if (!sendLoginVerification()) {
      marketSocket.close(1008, 'missing access token')
      return
    }
    startHeartbeat()
  }
  marketSocket.onclose = () => {
    clearHeartbeatTimer()
    marketSocket = null
    scheduleReconnect()
  }
  marketSocket.onerror = () => {
    if (marketSocket && marketSocket.readyState !== window.WebSocket.CLOSED) marketSocket.close()
  }
  marketSocket.onmessage = notifyMessageListeners
  return marketSocket
}

export function subscribeMarketSocketMessage(listener) {
  if (typeof listener !== 'function') return () => {}
  messageListeners.add(listener)
  return () => messageListeners.delete(listener)
}

export function disconnectMarketSocket() {
  clearReconnectTimer()
  clearHeartbeatTimer()
  if (marketSocket) {
    marketSocket.onclose = null
    marketSocket.close()
    marketSocket = null
  }
}
